import { useState } from "react";
import api from "../../utils/api";
import UploadImage from "../UploadImage";

export default function AddContract({ onSuccess }) {
  const [productCode, setProductCode] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleImageSelect = (file) => {
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !description) {
      alert("All fields are required.");
      return;
    }

    const formData = new FormData();
    formData.append("productCode", productCode);
    formData.append("name", name);
    formData.append("description", description);

    if (imageFile) {
      formData.append("image", imageFile);
    }

    try {
      await api.post("/products", formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("Product added successfully!");
      setProductCode("");
      setName("");
      setDescription("");
      setImageFile(null);
      setImagePreview(null);

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error.response?.data || error.message);
      alert(error.response?.data?.message || error.message);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
    >
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Add Product</h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Product Code
        </label>
        <input
          type="text"
          placeholder="Product Code"
          value={productCode}
          onChange={(e) => setProductCode(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Name
        </label>
        <input
          type="text"
          placeholder="Product Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Description
        </label>
        <input
          type="text"
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-800
                 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>

      <div className="mb-6">
        <UploadImage onFileSelect={handleImageSelect} preview={imagePreview} />
      </div>
      <button
        type="submit"
        className="w-full rounded-lg bg-green-500 py-2.5 text-white font-medium
               hover:bg-green-700 transition"
      >
        Add Product
      </button>
    </form>
  );
}
